import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { useProfileFeatureFlags } from './useProfileStores';
import {
    ICountriesList,
    ICountryWithZone,
    ICountryWithZoneList,
    IFilterParams,
    ISelectCountries,
} from '../../interfaces';

export function useCountriesSelect(): ISelectCountries[] {
    return useContext(MobXProviderContext).RootStore.countriesStore.select;
}

export function useCountriesWithZoneList(): ICountryWithZoneList {
    // ToDo: 29.01.2026 -  remove after implement newResponseFormatCountries feature flag
    const { newResponseFormatCountries } = useProfileFeatureFlags();
    const { countriesStore } = useContext(MobXProviderContext).RootStore;
    if (newResponseFormatCountries) {
        return countriesStore.select;
    } else {
        return countriesStore.countriesWithZoneList;
    }
}
export function useCountriesWithZoneListByZoneId(zoneId: string): ICountryWithZoneList {
    // ToDo: 17.09.2021 - check need use useCountriesWithZoneList().filter
    const list = useCountriesWithZoneList();
    return list.filter((c: ICountryWithZone) => c.zoneId === zoneId);
}

export function useCountriesTable(): ICountriesList {
    return useContext(MobXProviderContext).RootStore.countriesStore.list;
}

export function useCountriesFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.countriesStore.filterParams;
}
